export default {
  name: 'ui',
  namespaced: true,
  state: {
    footless: false,
  },
  mutations: {
    setFootless(state, footless) {
      state.footless = footless
    },
  },
}
